import "bootstrap/dist/css/bootstrap.min.css";
import {
    CitiesBox,
    CityNameList,
    CitiesBoxSubTitle,
} from "./nearByGridStyle";
import { DropdownOptions, FilterDropdownProps } from "../../../utils/types";

const NearByGridFilter = ({ options = [], selectedFilter, setSelectedFilter , setFilterFlag}: FilterDropdownProps) => {
    return (
        <CitiesBox className="city-box-main">
          <CitiesBoxSubTitle>Sort By</CitiesBoxSubTitle>
          {options?.slice(1,options?.length)?.map((option: DropdownOptions, index: number) => (
            <CityNameList
             className={selectedFilter === option?.value? `city-name-list active`:`city-name-list`}
              key={index+1}
              onClick={() =>{ setSelectedFilter(option?.value);setFilterFlag && setFilterFlag(true)}}
            >
              {option.label}  
            </CityNameList>
          ))}
        </CitiesBox>
    );
  };
  

export default NearByGridFilter;